import { BusinessLayout } from '@layouts/business/BusinessLayout'
import CompaniesPage from '@pages/business/company/CompaniesPage'
import CompanyPage from '@pages/business/company/CompanyPage'
import PoliciesPage from '@pages/business/policy/PoliciesPage'
import ReservationsPage from '@pages/business/reservation/ReservationsPage'
import { Navigate, RouteObject } from 'react-router-dom'

const businessRoutes: RouteObject[] = [
  {
    element: <BusinessLayout />,
    children: [
      { path: 'companies/list', element: <CompaniesPage /> },
      { path: 'companies/:companyId', element: <CompanyPage /> },
      { path: 'policies', element: <PoliciesPage /> },
      { path: 'reservations', element: <ReservationsPage /> },
      { index: true, element: <Navigate to="companies/list" replace /> },
      { path: '*', element: <Navigate to="/404" replace /> },
    ],
  },
]

export default businessRoutes
